import axios from "axios";
import React, {useEffect, useState} from "react";
import {baseUrl} from '../Univ.js';
function LabMachine() {
    const [labData, setLabData] = useState([]);
    const [isTransferring, setIsTransferring] = useState(false); // Track transfer status
    const [isSendingData, setIsSendingData] = useState(false); // Track data send status
    const [isReceivingData, setIsReceivingData] = useState(false); // Track data receive status
    const [isProcessingData, setIsProcessingData] = useState(false); // Track data processing status
    // Define fetchData function outside useEffect so it's accessible globally in the component
    const fetchData = async () => {
        try {
            const response = await axios.get(baseUrl + 'fetch-serial-results/');
            // Handle 204 No Content
            if (response.status === 204) {
                console.log('No new data available.');
                return; // Exit early, no new data to process
            }
            if (response.data.status === 'success') {
                // Check if the data field is available and not undefined
                const newData = response.data.data || [];
                setLabData(prevData => [...prevData, ...newData]);
            } else {
                console.error('Error fetching lab data:', response.data.message);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };
    const receiveWorkOrders = async () => {
        try {
            setIsReceivingData(true); // Indicate that data is being received
            const response = await axios.get(baseUrl + 'fetch-hl7-lab-results/');
            if (response.data.status === 'success') {
                console.log('Work orders received:', response.data.message);
                // Stop polling if transfer is complete
                if (response.data.message === 'Transfer complete') {
                    setIsTransferring(false); // Stop the transfer process
                }
                // Check if the data field is available and not undefined
                const newData = response.data.data || [];
                setLabData(prevData => [...prevData, ...newData]);
            } else {
                console.error('Error receiving work orders:', response.data.message);
            }
        } catch (error) {
            console.error('Error while receiving work orders:', error);
        } finally {
            setIsReceivingData(false); // Reset receiving state
        }
    };
    // Function to send work orders to the machine
    const sendWorkOrders = async () => {
        try {
            setIsSendingData(true); // Indicate that data is being sent
            const response = await axios.post(baseUrl + 'send-work-orders-to-machine/');
            if (response.data.status === 'success') {
                console.log('Work orders sent to machine:', response.data.message);
            } else {
                console.error('Error sending work orders:', response.data.message);
            }
        } catch (error) {
            console.error('Error while sending work orders:', error);
        } finally {
            setIsSendingData(false); // Reset sending state
        }
    };
    // Function to receive work orders from the machine
    // Function to process work orders
    const processWorkOrders = async () => {
        try {
            setIsProcessingData(true); // Indicate that data is being processed
            const response = await axios.post(baseUrl + 'process-raw-data/');
            if (response.data.status === 'success') {
                console.log('Work orders processed successfully:', response.data.message);
            } else {
                console.error('Error processing work orders:', response.data.message);
            }
        } catch (error) {
            console.error('Error while processing work orders:', error);
        } finally {
            setIsProcessingData(false); // Reset processing state
        }
    };
    useEffect(() => {
        let intervalId;
        if (isTransferring) {
            // Start polling when transfer begins
            fetchData(); // Fetch data immediately when transfer starts
            intervalId = setInterval(fetchData, 2000); // Poll every 5 seconds
        }
        // Cleanup function to stop polling when the component unmounts or transfer is complete
        return () => {
            clearInterval(intervalId);
            console.log('LabMachine component unmounted or transfer stopped.');
        };
    }, [isTransferring]); // Dependency on isTransferring to trigger polling
    return (
        <div>
            <h2>Lab Results</h2>
            <ul>
                {labData.map((result, index) => (
                    <li key={index}>
                        Result: {result.result}
                    </li>
                ))}
            </ul>

            {/* Button to start the transfer */}
            <button onClick={() => {
                if (!isTransferring) {
                    setIsTransferring(true); // Start transfer process
                }
            }}>
                {isTransferring ? 'Transferring...' : 'Start Transfer'}
            </button>

            {/* Button to send work order data */}
            <button
                onClick={sendWorkOrders}
                disabled={isSendingData}
            >
                {isSendingData ? 'Sending Data...' : 'Send Work Orders to Machine'}
            </button>

            {/* Button to receive work order data */}
            <button
                onClick={receiveWorkOrders}
                disabled={isReceivingData}
            >
                {isReceivingData ? 'Receiving Data...' : 'Receive Work Orders from Machine'}
            </button>

            {/* Button to process work order data */}
            <button
                onClick={processWorkOrders}
                disabled={isProcessingData}
            >
                {isProcessingData ? 'Processing Data...' : 'Process Work Orders'}
            </button>
        </div>
    );
}
export default LabMachine;
